// i18n for the Voluntary Burn panel in /vault (ES / EN / SK).
export const VOLUNTARY_BURN_I18N = {
  es: {
    title: "Quemar R₿L voluntariamente",
    subtitle: "Apoya el crecimiento del ecosistema",
    yourBalance: "Tu balance",
    amountToBurn: "Cantidad a quemar",
    burnButton: "Quemar R₿L",
    irreversibleWarning: "Esta acción es irreversible",
    confirmTitle: "Confirmar quemado",
    confirmText: "Estos tokens serán enviados a la dirección de quemado permanentemente.",
    confirm: "Confirmar quemado",
    cancel: "Cancelar",
    hallOfFlame: "Hall of Flame",
    hallSubtitle: "Los mayores contribuidores al ecosistema",
    totalBurned: "Total quemado",
    burners: "Burners",
    thisMonth: "Este mes",
    thankYou: "¡Gracias por apoyar el ecosistema RE₿EL!",
    rank: "Tu posición",
    max: "MAX",
    willBurn: "Vas a quemar",
    approxValue: "Valor aproximado",
    sentTo: "Estos tokens serán enviados a",
    permanentNote: "Esta acción es PERMANENTE e IRREVERSIBLE. Los tokens desaparecerán del supply para siempre.",
    areYouSure: "¿Estás seguro?",
    minBurn: "Mínimo: 1,000 R₿L",
    insufficientBalance: "Balance insuficiente",
    connectToBurn: "Conecta tu wallet para quemar",
    disconnect: "Desconectar wallet",
    wrongNet: "Cambia a Base L2",
    switchBase: "Cambiar a Base",
    confirmInWallet: "Confirma en tu wallet…",
    burning: "Quemando on-chain…",
    recording: "Registrando burn…",
    viewTx: "Ver TX en Basescan",
    burnedAmount: "Quemado",
    noBurnersYet: "Aún no hay burns voluntarios — sé el primero en entrar al Hall of Flame",
    badge_dragon: "Dragon Burner",
    badge_flame: "Flame Guardian",
    badge_spark: "Spark Holder",
    burnsLabel: "burns",
    loginFirst: "Inicia sesión para registrar tu burn",
    foreverNote: "Estos tokens serán quemados para siempre",
    recordFailed: "El burn se ejecutó on-chain pero no se pudo registrar. Guarda tu TX hash y reintenta.",
    shareOnX: "Compartir en X",
    shareText: "Acabo de quemar {amount} $RBL 🔥 para apoyar el ecosistema RE₿EL. Supply deflacionario, verificable on-chain en Base L2. Únete a la rebelión 👉",
  },
  en: {
    title: "Voluntarily burn R₿L",
    subtitle: "Support the ecosystem growth",
    yourBalance: "Your balance",
    amountToBurn: "Amount to burn",
    burnButton: "Burn R₿L",
    irreversibleWarning: "This action is irreversible",
    confirmTitle: "Confirm burn",
    confirmText: "These tokens will be sent to the burn address permanently.",
    confirm: "Confirm burn",
    cancel: "Cancel",
    hallOfFlame: "Hall of Flame",
    hallSubtitle: "Top contributors to the ecosystem",
    totalBurned: "Total burned",
    burners: "Burners",
    thisMonth: "This month",
    thankYou: "Thank you for supporting the RE₿EL ecosystem!",
    rank: "Your rank",
    max: "MAX",
    willBurn: "You are about to burn",
    approxValue: "Approximate value",
    sentTo: "These tokens will be sent to",
    permanentNote: "This action is PERMANENT and IRREVERSIBLE. The tokens will leave the supply forever.",
    areYouSure: "Are you sure?",
    minBurn: "Minimum: 1,000 R₿L",
    insufficientBalance: "Insufficient balance",
    connectToBurn: "Connect your wallet to burn",
    disconnect: "Disconnect wallet",
    wrongNet: "Switch to Base L2",
    switchBase: "Switch to Base",
    confirmInWallet: "Confirm in your wallet…",
    burning: "Burning on-chain…",
    recording: "Recording burn…",
    viewTx: "View TX on Basescan",
    burnedAmount: "Burned",
    noBurnersYet: "No voluntary burns yet — be the first to enter the Hall of Flame",
    badge_dragon: "Dragon Burner",
    badge_flame: "Flame Guardian",
    badge_spark: "Spark Holder",
    burnsLabel: "burns",
    loginFirst: "Log in to record your burn",
    foreverNote: "These tokens will be burned forever",
    recordFailed: "The burn executed on-chain but could not be recorded. Save your TX hash and retry.",
    shareOnX: "Share on X",
    shareText: "I just burned {amount} $RBL 🔥 to support the RE₿EL ecosystem. Deflationary supply, verifiable on-chain on Base L2. Join the rebellion 👉",
  },
  sk: {
    title: "Dobrovoľne spáliť R₿L",
    subtitle: "Podpor rast ekosystému",
    yourBalance: "Tvoj zostatok",
    amountToBurn: "Množstvo na spálenie",
    burnButton: "Spáliť R₿L",
    irreversibleWarning: "Táto akcia je nevratná",
    confirmTitle: "Potvrdiť spálenie",
    confirmText: "Tieto tokeny budú natrvalo odoslané na adresu spaľovania.",
    confirm: "Potvrdiť spálenie",
    cancel: "Zrušiť",
    hallOfFlame: "Sieň slávy plameňa",
    hallSubtitle: "Najväčší prispievatelia ekosystému",
    totalBurned: "Celkom spálené",
    burners: "Spaľovači",
    thisMonth: "Tento mesiac",
    thankYou: "Ďakujeme za podporu ekosystému RE₿EL!",
    rank: "Tvoje poradie",
    max: "MAX",
    willBurn: "Chystáš sa spáliť",
    approxValue: "Približná hodnota",
    sentTo: "Tieto tokeny budú odoslané na",
    permanentNote: "Táto akcia je TRVALÁ a NEVRATNÁ. Tokeny navždy zmiznú zo supply.",
    areYouSure: "Si si istý?",
    minBurn: "Minimum: 1 000 R₿L",
    insufficientBalance: "Nedostatočný zostatok",
    connectToBurn: "Pripoj peňaženku na spálenie",
    disconnect: "Odpojiť peňaženku",
    wrongNet: "Prepni na Base L2",
    switchBase: "Prepnúť na Base",
    confirmInWallet: "Potvrď v peňaženke…",
    burning: "Spaľujem on-chain…",
    recording: "Zaznamenávam burn…",
    viewTx: "Zobraziť TX na Basescan",
    burnedAmount: "Spálené",
    noBurnersYet: "Zatiaľ žiadne dobrovoľné burny — buď prvý v Sieni slávy plameňa",
    badge_dragon: "Dragon Burner",
    badge_flame: "Flame Guardian",
    badge_spark: "Spark Holder",
    burnsLabel: "burnov",
    loginFirst: "Prihlás sa pre zaznamenanie burnu",
    foreverNote: "Tieto tokeny budú spálené navždy",
    recordFailed: "Burn prebehol on-chain, ale nepodarilo sa ho zaznamenať. Ulož si TX hash a skús znova.",
    shareOnX: "Zdieľať na X",
    shareText: "Práve som spálil {amount} $RBL 🔥 na podporu ekosystému RE₿EL. Deflačný supply, overiteľné on-chain na Base L2. Pridaj sa k rebélii 👉",
  },
  "zh-CN": {
    title: "自愿销毁 R₿L",
    subtitle: "支持生态系统增长",
    yourBalance: "您的余额",
    amountToBurn: "销毁数量",
    burnButton: "销毁 R₿L",
    irreversibleWarning: "此操作不可逆转",
    confirmTitle: "确认销毁",
    confirmText: "这些代币将被永久发送到销毁地址。",
    confirm: "确认销毁",
    cancel: "取消",
    hallOfFlame: "火焰殿堂",
    hallSubtitle: "生态系统最大贡献者",
    totalBurned: "总销毁量",
    burners: "销毁者",
    thisMonth: "本月",
    thankYou: "感谢您支持 RE₿EL 生态系统!",
    rank: "您的排名",
    max: "最大",
    willBurn: "您将销毁",
    approxValue: "大约价值",
    sentTo: "这些代币将被发送到",
    permanentNote: "此操作是永久且不可逆转的。代币将永远从供应量中消失。",
    areYouSure: "您确定吗?",
    minBurn: "最低: 1,000 R₿L",
    insufficientBalance: "余额不足",
    connectToBurn: "连接您的钱包以进行销毁",
    disconnect: "断开钱包连接",
    wrongNet: "切换到 Base L2",
    switchBase: "切换到 Base",
    confirmInWallet: "在您的钱包中确认…",
    burning: "链上销毁中…",
    recording: "记录销毁中…",
    viewTx: "在 Basescan 上查看交易",
    burnedAmount: "已销毁",
    noBurnersYet: "暂无自愿销毁记录 — 成为第一个进入火焰殿堂的人",
    badge_dragon: "龙焰销毁者",
    badge_flame: "火焰守护者",
    badge_spark: "星火持有者",
    burnsLabel: "次销毁",
    loginFirst: "登录以记录您的销毁",
    foreverNote: "这些代币将被永久销毁",
    recordFailed: "销毁已在链上执行,但无法记录。请保存您的交易哈希并重试。",
    shareOnX: "在 X 上分享",
    shareText: "我刚刚销毁了 {amount} $RBL 🔥 以支持 RE₿EL 生态系统。通缩供应量,在 Base L2 上链上可验证。加入革命 👉",
  },
  de: {
    title: "R₿L freiwillig verbrennen",
    subtitle: "Unterstütze das Wachstum des Ökosystems",
    yourBalance: "Dein Guthaben",
    amountToBurn: "Zu verbrennender Betrag",
    burnButton: "R₿L verbrennen",
    irreversibleWarning: "Diese Aktion ist unwiderruflich",
    confirmTitle: "Verbrennung bestätigen",
    confirmText: "Diese Token werden dauerhaft an die Burn-Adresse gesendet.",
    confirm: "Verbrennung bestätigen",
    cancel: "Abbrechen",
    hallOfFlame: "Hall of Flame",
    hallSubtitle: "Die größten Unterstützer des Ökosystems",
    totalBurned: "Gesamt verbrannt",
    burners: "Burners",
    thisMonth: "Dieser Monat",
    thankYou: "Danke, dass du das RE₿EL-Ökosystem unterstützt!",
    rank: "Deine Position",
    max: "MAX",
    willBurn: "Du wirst verbrennen",
    approxValue: "Ungefährer Wert",
    sentTo: "Diese Token werden gesendet an",
    permanentNote: "Diese Aktion ist PERMANENT und UNWIDERRUFLICH. Die Token verschwinden für immer aus dem Supply.",
    areYouSure: "Bist du sicher?",
    minBurn: "Minimum: 1.000 R₿L",
    insufficientBalance: "Unzureichendes Guthaben",
    connectToBurn: "Verbinde dein Wallet zum Verbrennen",
    disconnect: "Wallet trennen",
    wrongNet: "Wechsle zu Base L2",
    switchBase: "Zu Base wechseln",
    confirmInWallet: "Bestätige in deinem Wallet…",
    burning: "Verbrennung on-chain…",
    recording: "Burn wird registriert…",
    viewTx: "TX auf Basescan ansehen",
    burnedAmount: "Verbrannt",
    noBurnersYet: "Noch keine freiwilligen Burns — sei der Erste in der Hall of Flame",
    badge_dragon: "Dragon Burner",
    badge_flame: "Flame Guardian",
    badge_spark: "Spark Holder",
    burnsLabel: "burns",
    loginFirst: "Melde dich an, um deinen Burn zu registrieren",
    foreverNote: "Diese Token werden für immer verbrannt",
    recordFailed: "Der Burn wurde on-chain ausgeführt, konnte aber nicht registriert werden. Speichere deinen TX-Hash und versuche es erneut.",
    shareOnX: "Auf X teilen",
    shareText: "Ich habe gerade {amount} $RBL verbrannt 🔥, um das RE₿EL-Ökosystem zu unterstützen. Deflationäres Supply, verifizierbar on-chain auf Base L2. Schließ dich der Rebellion an 👉",
  },
};

export const tBurn = (lang, key) => {
  const dict = VOLUNTARY_BURN_I18N[lang] || VOLUNTARY_BURN_I18N.es;
  if (dict[key] !== undefined) return dict[key];
  return VOLUNTARY_BURN_I18N.es[key] !== undefined ? VOLUNTARY_BURN_I18N.es[key] : key;
};

export default VOLUNTARY_BURN_I18N;
